import React from 'react'
import i18n from 'live/services/i18n'
import globalConfirmation from 'live/services/global-confirmation'
import styled from 'styled-components'

interface Props {
    onClick?(): void
    label?: string
    message?: string
    contentIdentifier?: string
    additonalWarnningMessage?:string
    className?: string
}

export function TrashButton({ onClick, label, message, contentIdentifier, additonalWarnningMessage, className }: Props): JSX.Element {
    const content = (
        <StyledContent>
            {message && 
                <>
                    <span className="highlighted">{`${i18n('This action can not be undone.')}`}</span>
                    <br/>
                    {message}
                </>
            }
            {!message && contentIdentifier &&
                <>
                    <span className="highlighted">{`${i18n("The action of removing")} "${contentIdentifier}" can not be undone.`}</span>
                    <br/>
                </>
            }
            {additonalWarnningMessage && 
                <span>{additonalWarnningMessage}</span>
            }
            {!message && !contentIdentifier && !additonalWarnningMessage &&
                <span className="highlighted">{`${i18n('This action can not be undone.')}`}</span>
            }
        </StyledContent>
    )

    return (
        <div onClick={() => globalConfirmation.confirm(content, () => onClick())} className={className}>
            <StyledTrash className="far fa-trash-alt" />
            {label ? <span>{label}</span> : null}
        </div>
    )
}

export const StyledTrash = styled.i`
    color: ${({ theme }) => theme['red-700']};
    padding-top: 2px;
    font-size: 13px;
    cursor: pointer;
    &:hover {
        color: ${({ theme }) => theme['red-500']};
    }
`

export const StyledContent = styled.p`
    display: flex;
    flex-direction: column;
    span {
        &.highlighted {
            font-weight: 600;
        }
    }
`
